<template>
    <div id="inbox-content">
        <div v-if="loading" class="loading-spinner"></div>
        <div v-else>
            <div v-if="answersData">
                <div class="content-header">
                    <h2>{{ answersData.formTitle }}</h2>
                </div>
                <div class="content-header">
                    <h6>Form Yanıtlanma Tarihi: {{ formattedDate }}</h6>
                </div>
                <div class="content-body">
                    <div v-if="specialAnswer" class="info-item special-card">
                        <span class="label">Kullanıcı Adı: {{ specialAnswer.value[0].username }}</span>
                        <span class="label">Tam Ad: {{ specialAnswer.value[0].fullName }}</span>
                    </div>
                    <div class="info-item" v-for="(answer, index) in filteredAnswers" :key="index" v-if="answer.fieldLabel">
                        <span class="label">{{ answer.fieldLabel }}</span>
                        <span class="value">
                        <template v-if="answer.fieldType === 'fileUpload'">
                            <ul>
                                <viewer :options="{ inline: false }">
                                    <li v-for="(url, idx) in answer.value" :key="idx" class="file-list-item">
                                        <template v-if="url.endsWith('.pdf')">
                                            <div class="pdf-file" @click="openFile(url)">
                                                <svg width="24" height="24" viewBox="0 0 24 24">
                                                    <path
                                                        d="M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z" />
                                                </svg>
                                                PDF File
                                            </div>
                                        </template>
                                        <template v-else-if="url.endsWith('.svg')">
                                            <div class="svg-file" @click="openFile(url)">
                                                <svg width="24" height="24" viewBox="0 0 24 24">
                                                    <path
                                                        d="M12 0L8.59 3.41 11.17 6H0v2h11.17l-2.58 2.59L12 12l6-6-6-6z" />
                                                </svg>
                                                SVG File
                                            </div>
                                        </template>
                                        <template v-else>
                                            <img :src="prependHttps(url)" :alt="'Image ' + (idx + 1)" />
                                        </template>
                                    </li>
                                </viewer>
                            </ul>
                        </template>
                        <template v-else>
                            {{ getAnswerValue(answer) }}
                        </template>
                    </span>
                    </div>
                </div>
            </div>
            <div v-else class="alert alert-warning">
                Form silindiği için cevapları görüntüleyemiyorsunuz.
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment/moment";

export default {
    name: "TicketInboxContents",
    props: {
        submissionId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            answersData: {},
            isModalVisible: false,
            selectedImage: "",
            loading: true,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        formattedDate() {
            if (this.answersData && this.answersData.submission && this.answersData.submission.createdAt) {
                return moment(this.answersData.submission.createdAt).format("DD MMMM YYYY HH:mm");
            }
            return "";
        },
        specialAnswer() {
            return this.answersData.answers.find(answer => answer.value && answer.value[0] && answer.value[0].username && answer.value[0].fullName);
        },
        filteredAnswers() {
            if (!this.answersData.answers) {
                return [];
            }
            return this.answersData.answers.filter(answer => !(answer.value && answer.value[0] && answer.value[0].username && answer.value[0].fullName)).sort((a, b) => a.order - b.order);
        },
    },
    watch: {
        submissionId: {
            immediate: true,
            handler() {
                this.getFormAnswers();
            },
        },
        answersData: {
            immediate: true,
            handler() {
                this.loading = false;
            },
        },
    },
    mounted() {
        this.getFormAnswers();
    },
    methods: {
        ...mapActions({
            updateFormStatus: "forms/updateFormStatus",
            getFormAnswersBySubmissionId: "forms/getFormAnswersBySubmissionId",
        }),
        async getFormAnswers() {
            try {
                this.loading = true;
                const data = await this.getFormAnswersBySubmissionId({
                    siteId: this.site._id,
                    submissionId: this.submissionId,
                });
                if (data && data.answers && data.answers.length > 0) {
                    this.answersData = data;
                } else {
                    this.answersData = null;
                }
            } catch (error) {
                console.error("Error fetching form answers:", error);
                this.answersData = null;
            } finally {
                this.loading = false;
            }
        },
        getAnswerValue(answer) {
            const value = answer.value;
            switch (answer.fieldType) {
                case "fullName":
                    return value.join(" ");
                case "email":
                case "shortText":
                case "longText":
                case "number":
                case "spinner":
                    return value[0];
                case "phone":
                    return value[0];
                case "address":
                    return value.join(", ");
                case "datePicker":
                case "hour":
                    return moment(value[0]).format("DD MMMM YYYY HH:mm");
                case "starRating":
                case "ratingScale":
                    return this.renderStars(parseInt(value[0]));
                case "multipleSelection":
                case "singleChoice":
                case "dropDownList":
                    return value.join(", ");
                case "fileUpload":
                    return "";
                default:
                    return value.join(", ");
            }
        },
        prependHttps(url) {
            if (url.startsWith("http")) {
                return url;
            }
            return `https://${url}`;
        },
        openModal(url) {
            this.selectedImage = url;
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
            this.selectedImage = "";
        },
        renderStars(rating) {
            return "★".repeat(rating) + "☆".repeat(5 - rating);
        },
        openFile(url) {
            window.open(this.prependHttps(url), "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
#inbox-content {
    font-family: 'Arial', sans-serif;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    color: #333;
    background-color: #f9f9f9;

    .loading-spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-top: 4px solid #0288d1;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
        margin: auto;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .content-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        background-color: #ffffff;
        border-bottom: 2px solid #ececec;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;

        h2 {
            margin: 0;
            font-size: 1.5rem;
            color: #333;
            font-weight: 600;
        }

        .button {
            display: flex;
            align-items: center;
            background-color: #0288d1;
            color: #fff;
            border: none;
            padding: 10px 20px;
            border-radius: 8px;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.3s ease;
            font-size: 1rem;
            font-weight: 500;

            i {
                margin-right: 8px;
                font-size: 1.2rem;
            }

            &:hover {
                background-color: #0277bd;
                transform: translateY(-2px);
            }

            &:active {
                background-color: #01579b;
                transform: translateY(0);
            }
        }
    }

    .content-body {
        .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            padding: 15px;
            border-radius: 8px;
            background-color: #ffffff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

            .label {
                color: #6f76a7;
                font-size: 1rem;
                font-weight: 600;
            }

            .value {
                color: #091551;
                font-size: 1rem;
                max-width: 500px;
                word-wrap: break-word;
            }

            .file-list-item {
                display: inline-block;
                width: 100px;
                margin-right: 10px;

                .pdf-file, .svg-file {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    transition: transform 0.2s ease-in-out;

                    svg {
                        margin-right: 5px;
                    }

                    &:hover {
                        transform: scale(1.05);
                    }
                }

                img {
                    width: 100%;
                    height: auto;
                    cursor: pointer;
                    transition: transform 0.2s ease-in-out;

                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }
        }

        .special-card {
            background-color: #f0f8ff;
            border: 1px solid #0288d1;
        }
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }

    .modal-content {
        position: relative;
        width: auto;
        height: auto;
    }

    .modal-content img {
        max-width: 900px;
        max-height: 900px;
    }

    .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: #fff;
        border: none;
        padding: 5px 10px;
        cursor: pointer;
    }
}
</style>
